import { render, staticRenderFns } from "./add-edit-dashboard.vue?vue&type=template&id=692e7ca6"
import script from "./add-edit-dashboard.vue?vue&type=script&lang=ts"
export * from "./add-edit-dashboard.vue?vue&type=script&lang=ts"
import style0 from "./add-edit-dashboard.vue?vue&type=style&index=0&id=692e7ca6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports